module.exports = __webpack_public_path__ + "img/noticeTop.c1c1a702.png";